<footer class="footer-bottom" style="margin-top: 20px;">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <div class="copyright"></div>
      </div>
    </div>
  </div>
</footer>
